let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3s5dS")).then(() => parcelRequire('2zKQ5'));